var React = require('react');

function IconNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.631 1l5.263 4L.63 9V1zM7.998 1.5v7","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconNext.defaultProps = {"width":"9","height":"10","fill":"none"};

module.exports = IconNext;

IconNext.default = IconNext;
